(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.announcement__item'));
      this.button = this.querySelector('[data-pause]');
      this.interval = Number(this.dataset.interval || 5) * 1000;
      this.index = 0;
      this.paused = false;

      if (this.items.length < 2) return;

      if (this.button) {
        this.button.addEventListener('click', () => {
          this.paused = !this.paused;
          if (this.paused) this.stop();
          else this.start();
          this.reflect();
        });
      }

      // Rotation waits while the bar is hovered or holds focus.
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('mouseleave', () => this.resume());
      this.addEventListener('focusout', () => this.resume());

      // In the theme editor, selecting a message shows it and holds it.
      this.onBlockSelect = (event) => {
        const index = this.items.indexOf(event.target);
        if (index === -1) return;
        this.stop();
        this.show(index);
      };
      this.onBlockDeselect = () => this.resume();
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.paused = true;
        this.reflect();
        return;
      }

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      if (this.onBlockDeselect) document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.next(), this.interval);
    }

    stop() {
      clearInterval(this.timer);
    }

    resume() {
      if (!this.paused && !this.matches(':hover') && !this.contains(document.activeElement)) this.start();
    }

    reflect() {
      if (!this.button) return;
      this.button.setAttribute('aria-pressed', String(this.paused));
      this.button.setAttribute('aria-label', this.paused ? this.button.dataset.labelPlay : this.button.dataset.labelPause);
    }

    show(index) {
      this.items[this.index].hidden = true;
      this.index = index;
      this.items[this.index].hidden = false;
    }

    next() {
      this.show((this.index + 1) % this.items.length);
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.sectionId = this.dataset.sectionId;

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-drawer-close]') || event.target === this.dialog) {
          this.close();
          return;
        }

        const removeCode = event.target.closest('[data-remove-code]');
        if (removeCode && window.ppCart && window.ppCart.setDiscount) {
          this.removeCode(removeCode);
          return;
        }

        const control = event.target.closest('[data-quantity-change]');
        if (!control || !window.ppCart) return;
        event.preventDefault();

        const line = control.closest('[data-line]');
        if (!line) return;
        const input = line.querySelector('[data-quantity-input]');
        const current = Number(input ? input.value : 1);
        const change = control.dataset.quantityChange;
        const quantity = change === 'remove' ? 0 : Math.max(0, current + Number(change));
        this.change(Number(line.dataset.line), quantity);
      });

      this.addEventListener('change', (event) => {
        const input = event.target.closest('[data-quantity-input]');
        if (!input || !window.ppCart) return;
        const line = input.closest('[data-line]');
        if (line) this.change(Number(line.dataset.line), Math.max(0, Number(input.value)));
      });

      document.addEventListener('click', (event) => {
        const link = event.target.closest('[data-cart-link]');
        if (!link) return;
        event.preventDefault();
        this.open();
      });

      document.addEventListener('submit', (event) => this.onSubmit(event));
    }

    open() {
      const dialog = this.dialog;
      if (!dialog) return;
      const cart = window.ppCart;

      if (dialog.open) {
        // Opened again while sliding out: stay open.
        if (cart && cart.cancelClose) cart.cancelClose(dialog);
        return;
      }

      // The quick add sheet may still be sliding out after an add. Open once it
      // has closed and returned focus to its trigger, so closing the drawer
      // later sends focus back there instead of to the page.
      const pending = cart && cart.whenDialogsClosed ? cart.whenDialogsClosed() : null;
      if (pending) {
        pending.then(() => {
          if (this.dialog === dialog && dialog.isConnected && !dialog.open) dialog.showModal();
        });
        return;
      }

      dialog.showModal();
    }

    close() {
      if (this.dialog && this.dialog.open) this.dialog.close();
    }

    onSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !window.ppCart) return;
      if (!/\/cart\/add$/.test(form.getAttribute('action') || '')) return;
      if (event.submitter && event.submitter.hasAttribute('data-native-submit')) return;

      event.preventDefault();
      this.add(form, event.submitter);
    }

    async add(form, submitter) {
      const button = submitter || form.querySelector('[type="submit"]');
      // aria-busy draws the shared button spinner (critical.css).
      window.ppCart.setBusy(button, true);
      this.hideError(form);

      try {
        const data = await window.ppCart.add(new FormData(form), this.sectionId);
        this.render(data.sections && data.sections[this.sectionId]);
        this.syncPage();
        form.dispatchEvent(new CustomEvent('pp:cart-added', { bubbles: true, detail: data }));
        this.open();

        const title = data.product_title || (data.items && data.items[0] && data.items[0].product_title) || '';
        if (window.ppAnnounce) window.ppAnnounce(this.dataset.textAdded.replace('%product%', title));
        this.refreshCount();
      } catch (error) {
        this.showFormError(form, error.message || this.dataset.textError);
      } finally {
        window.ppCart.setBusy(button, false);
      }
    }

    async change(line, quantity) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.setAttribute('aria-busy', 'true');

      const page = document.querySelector('cart-form');
      const sections = [this.sectionId, page && page.sectionId].filter(Boolean).join(',');
      const sectionsUrl = page ? window.location.pathname : undefined;

      try {
        const data = await window.ppCart.change({ line, quantity, sections, sectionsUrl }, this.controller.signal);
        this.render(data.sections && data.sections[this.sectionId]);
        if (page && typeof page.render === 'function') page.render(data.sections && data.sections[page.sectionId]);
        window.ppCart.updateCount(data.item_count);
        if (window.ppAnnounce) window.ppAnnounce(this.dataset.textUpdated);
      } catch (error) {
        if (error.name === 'AbortError') return;
        const box = this.querySelector('[data-cart-error]');
        if (box) {
          box.textContent = error.message || this.dataset.textError;
          box.hidden = false;
        }
      } finally {
        this.removeAttribute('aria-busy');
      }
    }

    // Takes the code off, then re-renders the drawer and, on the cart page, the
    // cart section. The panel is replaced, so focus moves on to checkout.
    async removeCode(button) {
      // One code change at a time, so an offer code still on its way can't
      // put this code back (or the reverse).
      if (window.ppCart.codesBusy) return;
      // Safari doesn't focus a tapped button, so check the whole panel: focus
      // is usually still on the close button, which the re-render destroys.
      const panel = this.querySelector('.cart-drawer__panel');
      const hadFocus = Boolean(panel && panel.contains(document.activeElement));
      window.ppCart.codesBusy = true;
      window.ppCart.setBusy(button, true);
      this.setAttribute('aria-busy', 'true');
      let removed = false;

      try {
        await window.ppCart.removeDiscount(button.dataset.removeCode);
        removed = true;
        await this.refresh();
        const active = document.activeElement;
        if (hadFocus || !active || active === document.body) {
          const next = this.querySelector('.cart-drawer__checkout') || this.querySelector('.cart-drawer__close');
          if (next) next.focus({ preventScroll: true });
          else if (this.dialog) this.dialog.focus({ preventScroll: true });
        }
        if (window.ppAnnounce) window.ppAnnounce(this.dataset.textCodeRemoved);
      } catch (error) {
        // The code is already off the cart when only the refresh failed, so a
        // reload shows the right totals instead of a stale pill.
        if (removed) {
          window.location.reload();
          return;
        }
        const box = this.querySelector('[data-cart-error]');
        if (box) {
          box.textContent = this.dataset.textError;
          box.hidden = false;
        }
      } finally {
        window.ppCart.codesBusy = false;
        window.ppCart.setBusy(button, false);
        this.removeAttribute('aria-busy');
      }
    }

    // Re-renders the drawer and, on the cart page, the cart section from the
    // cart as it is now. Shared by Remove and the offer code box, which moves
    // focus itself; rejects when the drawer's HTML can't be fetched.
    async refresh() {
      const page = document.querySelector('cart-form');
      const sections = [this.sectionId, page && page.sectionId].filter(Boolean).join(',');
      const response = await fetch(`${window.location.pathname}?sections=${sections}`);
      const data = response.ok ? await response.json() : {};
      if (!data[this.sectionId]) throw new Error('');
      this.render(data[this.sectionId]);
      if (page && typeof page.render === 'function') page.render(data[page.sectionId]);
    }

    render(html) {
      if (!html) return;
      const fresh = window.ppCart.parseSection(html, '.cart-drawer__panel');
      const panel = this.querySelector('.cart-drawer__panel');
      if (fresh && panel) {
        panel.innerHTML = fresh.innerHTML;
        // Swapped-in images are already cached; skip the first-load fade so they don't blink.
        panel.querySelectorAll('img').forEach((img) => img.classList.add('is-loaded'));
      }
    }

    async syncPage() {
      const page = document.querySelector('cart-form');
      if (!page || !page.sectionId) return;
      try {
        const response = await fetch(`${window.location.pathname}?sections=${page.sectionId}`);
        const data = await response.json();
        if (typeof page.render === 'function') page.render(data[page.sectionId]);
      } catch (error) {
        return;
      }
    }

    async refreshCount() {
      try {
        const response = await fetch(`${window.ppCart.root}cart.js`, { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        window.ppCart.updateCount(cart.item_count);
      } catch (error) {
        return;
      }
    }

    hideError(form) {
      const box = form.querySelector('[data-form-status]');
      if (box) box.hidden = true;
    }

    showFormError(form, text) {
      let box = form.querySelector('[data-form-status]');
      if (!box) {
        box = document.createElement('p');
        box.className = 'form-status form-status--error';
        box.setAttribute('data-form-status', '');
        box.setAttribute('role', 'alert');
        form.append(box);
      }
      box.textContent = text;
      box.hidden = false;
      if (window.ppAnnounce) window.ppAnnounce(text);
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartForm extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;

      this.addEventListener('click', (event) => {
        const removeCode = event.target.closest('[data-remove-code]');
        if (removeCode && window.ppCart && window.ppCart.setDiscount) {
          this.removeCode(removeCode);
          return;
        }

        const control = event.target.closest('[data-quantity-change]');
        if (!control || !window.ppCart) return;
        event.preventDefault();

        const line = control.closest('[data-line]');
        if (!line) return;
        const input = line.querySelector('[data-quantity-input]');
        const current = Number(input ? input.value : 1);
        const change = control.dataset.quantityChange;
        const quantity = change === 'remove' ? 0 : Math.max(0, current + Number(change));
        this.update(Number(line.dataset.line), quantity);
      });

      this.addEventListener('change', (event) => {
        const input = event.target.closest('[data-quantity-input]');
        if (!input || !window.ppCart) return;
        const line = input.closest('[data-line]');
        if (line) this.update(Number(line.dataset.line), Math.max(0, Number(input.value)));
      });
    }

    async update(line, quantity) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.setAttribute('aria-busy', 'true');

      const drawer = document.querySelector('cart-drawer');
      const sections = [this.sectionId, drawer && drawer.sectionId].filter(Boolean).join(',');

      try {
        const data = await window.ppCart.change(
          { line, quantity, sections, sectionsUrl: `${window.ppCart.root}cart` },
          this.controller.signal
        );
        this.render(data.sections && data.sections[this.sectionId]);
        if (drawer && typeof drawer.render === 'function') drawer.render(data.sections && data.sections[drawer.sectionId]);
        window.ppCart.updateCount(data.item_count);
        if (window.ppAnnounce) window.ppAnnounce(this.dataset.textUpdated);
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.showError(error.message || this.dataset.textError);
      } finally {
        this.removeAttribute('aria-busy');
      }
    }

    // Takes the code off, then re-renders this section and the drawer. The
    // button is replaced, so focus moves on to checkout.
    async removeCode(button) {
      // One code change at a time, so an offer code still on its way can't
      // put this code back (or the reverse).
      if (window.ppCart.codesBusy) return;
      // Safari doesn't focus a tapped button, so check the whole form: an
      // earlier focus inside it is destroyed by the re-render too.
      const hadFocus = this.contains(document.activeElement);
      window.ppCart.codesBusy = true;
      window.ppCart.setBusy(button, true);
      this.setAttribute('aria-busy', 'true');
      let removed = false;

      try {
        await window.ppCart.removeDiscount(button.dataset.removeCode);
        removed = true;
        await this.refresh();
        if (hadFocus) {
          const next = this.querySelector('.cart__checkout');
          if (next) next.focus({ preventScroll: true });
        }
        if (window.ppAnnounce) window.ppAnnounce(this.dataset.textCodeRemoved);
      } catch (error) {
        // The code is already off the cart when only the refresh failed, so a
        // reload shows the right totals.
        if (removed) window.location.reload();
        else this.showError(this.dataset.textError);
      } finally {
        window.ppCart.codesBusy = false;
        window.ppCart.setBusy(button, false);
        this.removeAttribute('aria-busy');
      }
    }

    // Re-renders this section and the drawer from the cart as it is now.
    // Shared by Remove and the offer code box, which moves focus itself;
    // rejects when this section's HTML can't be fetched.
    async refresh() {
      const drawer = document.querySelector('cart-drawer');
      const sections = [this.sectionId, drawer && drawer.sectionId].filter(Boolean).join(',');
      const response = await fetch(`${window.ppCart.root}cart?sections=${sections}`);
      const data = response.ok ? await response.json() : {};
      if (!data[this.sectionId]) throw new Error('');
      this.render(data[this.sectionId]);
      if (drawer && typeof drawer.render === 'function') drawer.render(data[drawer.sectionId]);
    }

    render(html) {
      if (!html) return;
      const fresh = window.ppCart.parseSection(html, 'cart-form');
      if (fresh) {
        this.innerHTML = fresh.innerHTML;
        // Swapped-in images are already cached; skip the first-load fade so they don't blink.
        this.querySelectorAll('img').forEach((img) => img.classList.add('is-loaded'));
      }
    }

    showError(text) {
      const box = this.querySelector('[data-cart-error]');
      if (!box) return;
      box.textContent = text;
      box.hidden = false;
    }
  }

  if (!customElements.get('cart-form')) {
    customElements.define('cart-form', CartForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionSort extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector('select');
      const button = this.querySelector('button');
      if (!select) return;
      if (button) button.hidden = true;

      select.addEventListener('change', () => {
        const form = select.form;
        if (!form) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }
  }

  if (!customElements.get('collection-sort')) {
    customElements.define('collection-sort', CollectionSort);
  }

  /* Filter buttons for product groups: show one group at a time. The address
     keeps the group (#Group-…) so a shared link opens the same filter, and
     selecting a group in the theme editor shows it. */
  class CollectionGroups extends HTMLElement {
    connectedCallback() {
      this.groups = Array.from(this.querySelectorAll('.collection-group'));
      this.links = Array.from(this.querySelectorAll('.collection__category'));
      this.status = this.querySelector('[data-group-status]');
      this.onClick = this.onClick.bind(this);
      this.onHashChange = this.onHashChange.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      this.addEventListener('click', this.onClick);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      window.addEventListener('hashchange', this.onHashChange);

      const linked = this.find(window.location.hash);
      if (linked) this.show(linked, { scroll: 'auto' });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      window.removeEventListener('hashchange', this.onHashChange);
    }

    find(hash) {
      const id = hash.replace(/^#/, '');
      return id ? this.groups.find((group) => group.id === id) : undefined;
    }

    onClick(event) {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('.collection__category');
      const group = link && this.find(link.hash);
      if (!group) return;

      event.preventDefault();
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.show(group, { scroll: smooth ? 'smooth' : 'auto', announce: true });
      const url = group.id === 'Group-all' ? window.location.pathname + window.location.search : link.hash;
      history.replaceState(history.state, '', url);
    }

    onHashChange() {
      const group = this.find(window.location.hash);
      if (group) this.show(group, { scroll: 'auto' });
    }

    onBlockSelect(event) {
      const group = event.target.closest('.collection-group');
      if (group && this.contains(group)) this.show(group, { scroll: 'auto' });
    }

    show(group, { scroll, announce = false } = {}) {
      let current;
      this.groups.forEach((item) => item.classList.toggle('is-active', item === group));
      this.links.forEach((link) => {
        if (link.hash === `#${group.id}`) {
          link.setAttribute('aria-current', 'true');
          current = link;
        } else {
          link.removeAttribute('aria-current');
        }
      });
      if (!current) return;
      if (scroll) this.keepInView(current, scroll);
      if (announce && this.status) {
        this.status.textContent = `${current.textContent.trim()}: ${group.dataset.count}`;
      }
    }

    /* On phones the buttons scroll sideways; bring the chosen one into view
       without moving the page itself. */
    keepInView(link, behavior) {
      const list = link.closest('.collection__category-list');
      if (!list || list.scrollWidth <= list.clientWidth) return;
      const listBox = list.getBoundingClientRect();
      const linkBox = link.getBoundingClientRect();
      if (linkBox.left >= listBox.left && linkBox.right <= listBox.right) return;
      list.scrollBy({ left: linkBox.left - listBox.left - (listBox.width - linkBox.width) / 2, behavior });
    }
  }

  if (!customElements.get('collection-groups')) {
    customElements.define('collection-groups', CollectionGroups);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flavour-slides"] && !Shopify.designMode) return;
  try {
    
  class FlavourSlides extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.fslide'));
      if (this.slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      // Phones and short viewports keep the stacked layout: a viewport-height
      // sticky stage clips its own buttons there.
      if (window.matchMedia('(max-width: 749px), (max-height: 640px)').matches) return;

      this.track = this.querySelector('.fslides__track');
      this.nav = this.querySelector('.fslides__nav');
      this.dots = Array.from(this.querySelectorAll('.fslides__dot'));
      this.index = 0;
      this.classList.add('is-ready');
      this.paintNav(this.slides[0]);

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      this.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-goto]');
        if (!dot) return;
        const target = Number(dot.dataset.goto);
        const span = this.track.offsetHeight - window.innerHeight;
        const step = span / this.slides.length;
        window.scrollTo({
          top: this.track.offsetTop + step * (target + 0.5),
          behavior: 'smooth',
        });
      });

      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.select();
      });
    }

    select() {
      const rect = this.track.getBoundingClientRect();
      const span = rect.height - window.innerHeight;
      const progress = span > 0 ? Math.min(Math.max(-rect.top / span, 0), 1) : 0;
      const next = Math.min(this.slides.length - 1, Math.floor(progress * this.slides.length));
      if (next === this.index) return;

      this.index = next;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === next));
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === next)));
      this.paintNav(this.slides[next]);
    }

    paintNav(slide) {
      if (!this.nav || !slide) return;
      this.nav.style.setProperty('--ink', slide.style.getPropertyValue('--ink'));
    }
  }

  if (!customElements.get('flavour-slides')) {
    customElements.define('flavour-slides', FlavourSlides);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  class FooterGroups extends HTMLElement {
    connectedCallback() {
      this.wide = window.matchMedia('(min-width: 750px)');
      this.sync = this.sync.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      this.wide.addEventListener('change', this.sync);
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      // From 750px up the groups are plain columns, so a click on a heading
      // must not fold one away.
      this.addEventListener('click', (event) => {
        if (this.wide.matches && event.target.closest('.footer__summary')) event.preventDefault();
      });

      this.sync();
    }

    disconnectedCallback() {
      this.wide.removeEventListener('change', this.sync);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    sync() {
      const wide = this.wide.matches;
      this.querySelectorAll(':scope > .footer__group').forEach((group) => {
        group.open = wide;
        const summary = group.querySelector(':scope > .footer__summary');
        if (!summary) return;
        if (wide) {
          summary.setAttribute('tabindex', '-1');
        } else {
          summary.removeAttribute('tabindex');
        }
      });
    }

    // The theme editor opens the group holding the block being edited.
    onBlockSelect(event) {
      const group = event.target.closest && event.target.closest('.footer__group');
      if (group && this.contains(group)) group.open = true;
    }
  }

  if (!customElements.get('footer-groups')) {
    customElements.define('footer-groups', FooterGroups);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();

      if (this.classList.contains('header--categories')) this.setupNavFit();

      this.addEventListener('click', (event) => {
        // A menu link to a section of the page on screen (an Offers category
        // while on Offers) closes the menu before scrolling there.
        const sectionLink = event.target.closest('a[href*="#"]');
        if (sectionLink && this.scrollToSection(event, sectionLink)) return;

        // The menu or search toggle closes its open overlay the soft way too.
        const summary = event.target.closest('summary');
        const owner = summary && summary.parentElement;
        if (owner && owner.open && owner.matches('.drawer, .search')) {
          event.preventDefault();
          this.closeDetails(owner);
          return;
        }

        // A click elsewhere in the header (the logo, a gap in the row) closes
        // Products or More, as a click outside the header does.
        this.querySelectorAll('.header__dropdown[open]').forEach((dropdown) => {
          // closeDetails also folds Products unfolded inside More.
          if (!dropdown.contains(event.target)) this.closeDetails(dropdown);
        });

        if (event.target.closest('[data-close]')) {
          const details = event.target.closest('details');
          if (details) this.closeDetails(details);
        }
      });

      // Listened for on the document: Safari does not focus a clicked summary,
      // so after a mouse click the key event starts outside the header.
      this.onKeydown = this.onKeydown.bind(this);
      document.addEventListener('keydown', this.onKeydown);

      // Tabbing out of Products or More closes it. Only the row's own
      // dropdowns: their panels float, so closing one never moves the link a
      // pointer is pressing (Products unfolded inside More would).
      this.addEventListener('focusout', (event) => {
        if (!event.relatedTarget) return;
        this.querySelectorAll('.header__dropdown[open]').forEach((dropdown) => {
          if (dropdown.parentElement.closest('.header__dropdown')) return;
          if (dropdown.contains(event.target) && !dropdown.contains(event.relatedTarget)) {
            this.closeDetails(dropdown);
          }
        });
      });

      this.addEventListener('toggle', (event) => {
        const details = event.target;
        const overlay = details.matches('.drawer, .search');

        if (details.open) {
          // Disclosures inside the one opening stay as rendered, so the phone
          // menu keeps Products unfolded on a category page.
          this.openDisclosures().forEach((other) => {
            if (other === details || other.contains(details) || details.contains(other)) return;
            other.open = false;
          });
          if (!overlay) return;
          // The rest of the page is inert while an overlay is open, and focus
          // moves into it.
          this.setInert(true);
          const target = details.querySelector('input[type="search"], button[data-close]');
          if (target) target.focus();
        } else if (overlay && !this.querySelector('.drawer[open], .search[open]')) {
          this.setInert(false);
          const summary = details.querySelector('summary');
          if (summary) summary.focus();
        }
      }, true);

      document.addEventListener('click', (event) => {
        if (this.contains(event.target)) return;
        this.closeAll();
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('keydown', this.onKeydown);
      if (this.navObserver) this.navObserver.disconnect();
      if (this.desktop) this.desktop.removeEventListener('change', this.fitNav);
      if (document.fonts && this.scheduleFit) document.fonts.removeEventListener('loadingdone', this.scheduleFit);
      if (this.fitFrame) cancelAnimationFrame(this.fitFrame);
    }

    // Keeps the nav in one row: items that do not fit move, last first, into
    // the More menu at the end of the row. Products moves as a whole and
    // unfolds inside More.
    setupNavFit() {
      this.nav = this.querySelector('.header__nav');
      this.navList = this.nav && this.nav.querySelector('.header__list');
      this.more = this.navList && this.navList.querySelector('[data-nav-more]');
      this.moreList = this.more && this.more.querySelector('[data-nav-more-list]');
      if (!this.moreList || !('ResizeObserver' in window)) return;

      this.navItems = Array.from(this.navList.children).filter((item) => item !== this.more);
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.fitNav = this.fitNav.bind(this);
      this.navObserver = new ResizeObserver(() => this.scheduleFit());
      this.navObserver.observe(this.nav);
      this.desktop.addEventListener('change', this.fitNav);
      // Web fonts (the Marathi ones load without blocking) change link widths
      // without resizing the nav, so refit whenever a font finishes loading.
      this.scheduleFit = this.scheduleFit.bind(this);
      if (document.fonts) {
        document.fonts.addEventListener('loadingdone', this.scheduleFit);
        document.fonts.ready.then(this.scheduleFit);
      }
      this.fitNav();
    }

    scheduleFit() {
      if (this.fitFrame) return;
      this.fitFrame = requestAnimationFrame(() => {
        this.fitFrame = null;
        this.fitNav();
      });
    }

    rowOverflows() {
      const items = Array.from(this.navList.children).filter((item) => !item.hidden);
      const gap = parseFloat(getComputedStyle(this.navList).columnGap) || 0;
      const needed = items.reduce((total, item) => total + item.getBoundingClientRect().width, 0)
        + gap * Math.max(items.length - 1, 0);
      return needed > this.navList.clientWidth + 1;
    }

    fitNav() {
      // Fonts can finish loading while a menu is open, so an unchanged fit
      // leaves open menus open and puts focus back (moving a node drops it).
      const focused = this.nav.contains(document.activeElement) ? document.activeElement : null;
      const movedBefore = this.moreList.children.length;

      this.navItems.forEach((item) => this.navList.insertBefore(item, this.more));
      this.more.hidden = true;

      if (this.desktop.matches) {
        this.nav.setAttribute('data-fitted', '');
        if (this.rowOverflows()) {
          this.more.hidden = false;
          for (let index = this.navItems.length - 1; index >= 0; index -= 1) {
            this.moreList.prepend(this.navItems[index]);
            if (!this.rowOverflows()) break;
          }
        }
      } else {
        this.nav.removeAttribute('data-fitted');
      }

      if (this.moreList.children.length !== movedBefore) {
        this.nav.querySelectorAll('details[open]').forEach((details) => {
          details.open = false;
        });
      }

      if (focused && document.activeElement !== focused) {
        focused.focus({ preventScroll: true });
        // The focused link may now sit in the closed More menu.
        if (document.activeElement !== focused && !this.more.hidden) {
          this.more.querySelector('summary').focus({ preventScroll: true });
        }
      }
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      const live = this.openDisclosures();
      if (!live.length) return;
      const open = (this.contains(event.target) && event.target.closest('details[open]')) || live[0];

      // Products inside the open More menu closes on its own first, so focus
      // stays in More; the next Escape closes More.
      const parent = open && open.parentElement.closest('details[open]');
      if (parent && parent.matches('.header__dropdown') && open.matches('.header__dropdown')) {
        open.open = false;
        open.querySelector(':scope > summary').focus();
        return;
      }

      this.closeAll();
      // Overlays get focus back from the toggle handler; dropdowns such as
      // Products and More need it here, or focus is lost inside the closed menu.
      if (open && !open.closest('.drawer, .search')) {
        const summary = open.querySelector(':scope > summary');
        if (summary) summary.focus();
      }
    }

    closeAll() {
      // Outermost disclosures only: closeDetails closes the ones nested inside
      // (menu accordions) after the overlay has slid out, so they do not
      // collapse mid-animation.
      this.openDisclosures().forEach((details) => {
        const parent = details.parentElement && details.parentElement.closest('details[open]');
        if (!parent) this.closeDetails(details);
      });
    }

    // Open disclosures a visitor can see. The phone Products group is rendered
    // open inside the closed drawer on a category page; it stays that way
    // until the drawer itself closes (closeDetails), not on any page click.
    openDisclosures() {
      return Array.from(this.querySelectorAll('details[open]')).filter((details) => {
        const overlay = details.parentElement && details.parentElement.closest('.drawer, .search');
        return !overlay || overlay.open;
      });
    }

    // Same-page section links: close the open menu, then scroll. The drawer's
    // scroll lock lifts only after its slide-out (up to 400ms), so the scroll
    // waits for it.
    scrollToSection(event, link) {
      if (link.origin !== location.origin || link.pathname !== location.pathname || !link.hash) return false;
      const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
      if (!target) return false;

      event.preventDefault();
      const overlayOpen = Boolean(this.querySelector('.drawer[open], .search[open]'));
      this.closeAll();
      const go = () => {
        history.pushState(null, '', link.hash);
        target.scrollIntoView({ behavior: this.reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
      };
      if (overlayOpen) setTimeout(go, 450);
      else go();
      return true;
    }

    // The menu drawer and search slide out, then close; the toggle handler
    // restores focus and inertness once they are really closed. Any other
    // disclosure closes at once.
    closeDetails(details) {
      if (!details.open || details.classList.contains('is-closing')) return;

      const close = () => {
        details.querySelectorAll('details[open]').forEach((inner) => {
          inner.open = false;
        });
        details.open = false;
        details.classList.remove('is-closing');
      };

      const panel = details.matches('.drawer, .search')
        ? details.querySelector(':scope > .drawer__panel, :scope > .search__panel')
        : null;
      if (!panel || this.reducedMotion.matches) {
        close();
        return;
      }

      details.classList.add('is-closing');
      const name = getComputedStyle(panel).animationName;
      if (!name || name === 'none') {
        close();
        return;
      }

      let timer = null;
      const onEnd = (event) => {
        if (event.target === panel && event.animationName === name) finish();
      };
      const finish = () => {
        clearTimeout(timer);
        panel.removeEventListener('animationend', onEnd);
        close();
      };
      panel.addEventListener('animationend', onEnd);
      timer = setTimeout(finish, 400);
    }

    setInert(state) {
      document.querySelectorAll('#main-content, .footer').forEach((element) => {
        element.inert = state;
      });
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.classList.toggle('header--scrolled', window.scrollY > 8);
        this.ticking = false;
      });
    }
  }

  if (!customElements.get('site-header')) {
    customElements.define('site-header', SiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  class MarqueeStrip extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('[data-pause]');
      if (!button) return;

      button.addEventListener('click', () => {
        const paused = this.classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.labelPlay : button.dataset.labelPause);
      });
    }
  }

  if (!customElements.get('marquee-strip')) {
    customElements.define('marquee-strip', MarqueeStrip);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-cards"] && !Shopify.designMode) return;
  try {
    
  class OfferCardCode extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-copy]');
      // Without the async clipboard (older browsers, insecure previews) the
      // button stays hidden and the code can still be selected by hand.
      if (!this.button || !navigator.clipboard || !window.isSecureContext) return;

      this.label = this.querySelector('[data-copy-label]');
      this.idleLabel = this.label ? this.label.textContent : '';
      this.controller = new AbortController();
      this.button.addEventListener('click', () => this.copy(), { signal: this.controller.signal });
      this.button.hidden = false;
    }

    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
    }

    async copy() {
      try {
        await navigator.clipboard.writeText(this.dataset.code);
      } catch (error) {
        this.selectCode();
        return;
      }

      this.button.classList.add('is-copied');
      if (this.label) this.label.textContent = this.dataset.textCopied;
      if (window.ppAnnounce) window.ppAnnounce(this.dataset.announce);

      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.button.classList.remove('is-copied');
        if (this.label) this.label.textContent = this.idleLabel;
      }, 2000);
    }

    // A refused write (permissions, an old WebView) still leaves the code
    // selected, ready for the system copy menu.
    selectCode() {
      const value = this.querySelector('[data-code-value]');
      const selection = window.getSelection();
      if (!value || !selection) return;
      const range = document.createRange();
      range.selectNodeContents(value);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  if (!customElements.get('offer-card-code')) {
    customElements.define('offer-card-code', OfferCardCode);
  }

  class OfferCombo extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-combo-form]');
      if (!this.form) return;

      this.controller = new AbortController();
      const { signal } = this.controller;

      this.form.addEventListener(
        'change',
        (event) => {
          if (event.target.matches('[data-combo-select]')) this.update(event.target.closest('[data-combo-row]'));
        },
        { signal }
      );
      this.form.addEventListener('submit', (event) => this.add(event), { signal });

      // A page restored from history can keep a changed select while the
      // prices still show the defaults.
      this.querySelectorAll('[data-combo-select]').forEach((select) => {
        const option = select.selectedOptions[0];
        if (option && !option.defaultSelected) this.update(select.closest('[data-combo-row]'));
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    // Prices keep the server's text until the shared money formatter exists.
    update(row) {
      const cart = window.ppCart;
      if (!row || !cart || typeof cart.formatMoney !== 'function') return;

      const select = row.querySelector('[data-combo-select]');
      const option = select && select.selectedOptions[0];
      const price = row.querySelector('[data-combo-price]');
      if (!option || !price) return;

      price.dataset.price = option.dataset.price;
      price.textContent = cart.formatMoney(option.dataset.price);
      this.setImage(row, option.dataset.image);
      this.renderTotals(cart);
    }

    renderTotals(cart) {
      const prices = [...this.querySelectorAll('[data-combo-price]')].map((node) => Number(node.dataset.price) || 0);
      const regular = prices.reduce((sum, price) => sum + price, 0);
      // Same cap as the Liquid: the saving comes off the second product only.
      const saving = Math.max(0, Math.min(Number(this.dataset.saving) || 0, prices[prices.length - 1] || 0));
      const savingText = cart.formatMoney(saving);

      const setText = (selector, text) => {
        const node = this.querySelector(selector);
        if (node) node.textContent = text;
      };
      setText('[data-combo-total]', cart.formatMoney(regular - saving));
      setText('[data-combo-regular]', cart.formatMoney(regular));

      const priceBox = this.querySelector('[data-combo-prices]');
      if (priceBox) priceBox.classList.toggle('price--on-sale', saving > 0);
      const compare = this.querySelector('[data-combo-compare]');
      if (compare) compare.hidden = saving <= 0;

      this.querySelectorAll('[data-combo-saving], [data-combo-text]').forEach((node) => {
        if (node.dataset.template) node.textContent = node.dataset.template.replace('%amount%', savingText);
        if (node.hasAttribute('data-combo-saving')) node.hidden = saving <= 0;
      });
    }

    setImage(row, source) {
      const image = row.querySelector('.offer-combo__tile img');
      if (!image || !source) return;

      const sized = (width) => {
        const url = new URL(source, window.location.href);
        url.searchParams.set('width', String(width));
        return url.toString();
      };
      image.srcset = [72, 144, 216].map((width) => `${sized(width)} ${width}w`).join(', ');
      image.src = sized(216);
    }

    async add(event) {
      const cart = window.ppCart;
      // Without the cart helpers the form posts to /cart/add as usual.
      if (!cart || typeof cart.add !== 'function') return;
      event.preventDefault();
      // Browsers without event.submitter skip the drawer's data-native-submit
      // check, so keep the submit from reaching its document listener too.
      event.stopPropagation();

      const button = event.submitter || this.form.querySelector('[type="submit"]');
      if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;

      // The layout renders the drawer only when the cart type is "drawer".
      const drawer = document.querySelector('cart-drawer');
      const useDrawer = Boolean(drawer && typeof drawer.open === 'function' && drawer.sectionId);
      const status = this.querySelector('[data-combo-status]');
      if (status) status.hidden = true;
      cart.setBusy(button, true);

      let data;
      try {
        data = await cart.add(new FormData(this.form), useDrawer ? drawer.sectionId : undefined);
      } catch (error) {
        cart.setBusy(button, false);
        // Only HTTP errors carry Shopify's message; a dropped connection
        // rejects with the browser's own English text.
        this.showError(error.status ? error.message || this.dataset.textError : this.dataset.textError);
        return;
      }

      this.form.dispatchEvent(new CustomEvent('pp:cart-added', { bubbles: true, detail: data }));

      // The cart page itself confirms the add, so the button stays busy
      // until it loads.
      if (!useDrawer) {
        window.location.assign(this.dataset.cartUrl);
        return;
      }

      cart.setBusy(button, false);
      drawer.render(data.sections && data.sections[drawer.sectionId]);
      if (typeof drawer.refreshCount === 'function') drawer.refreshCount();
      drawer.open();
      if (window.ppAnnounce) window.ppAnnounce(this.dataset.textAdded);
    }

    // Shopify's message names the problem, such as a size that just sold out.
    showError(text) {
      const status = this.querySelector('[data-combo-status]');
      if (status) {
        status.textContent = text;
        status.hidden = false;
      }
      if (window.ppAnnounce) window.ppAnnounce(text);
    }
  }

  if (!customElements.get('offer-combo')) {
    customElements.define('offer-combo', OfferCombo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-slideshow"] && !Shopify.designMode) return;
  try {
    
  class OfferSlideshow extends HTMLElement {
    static timings = {
      fade: { exit: 760, enter: 1450 },
      push: { exit: 880, enter: 1250 },
    };

    // Remembers the slide picked in the theme editor across section re-renders.
    static selected = new Map();

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.offer-slide'));
      if (this.slides.length < 2) return;

      this.viewport = this.querySelector('.offer-slideshow__viewport');
      this.tabs = Array.from(this.querySelectorAll('.offer-slideshow__tab'));
      this.rotation = this.querySelector('[data-rotation]');
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = Math.max(4, Number(this.dataset.interval) || 6) * 1000;
      this.timing = OfferSlideshow.timings[this.dataset.animation] || OfferSlideshow.timings.fade;
      this.rtl = document.documentElement.dir === 'rtl';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.holds = new Set();
      this.timer = null;
      this.remaining = this.interval;
      this.startedAt = 0;
      this.generation = 0;
      this.finishTimers = [];
      this.fill = null;
      this.drag = null;
      this.moved = false;
      this.userStopped = !this.autoplay || this.reducedMotion.matches;
      this.controller = new AbortController();

      const options = { signal: this.controller.signal };

      if (this.rotation) {
        this.rotation.addEventListener('click', () => this.toggleRotation(), options);
      }
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.step(-1), options);
      this.querySelector('[data-next]')?.addEventListener('click', () => this.step(1), options);
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.goTo(i, { dir: i > this.index ? 1 : -1 }), options);
        tab.addEventListener('keydown', (event) => this.onTabKeydown(event, i), options);
      });

      this.viewport.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') this.hold('hover');
      }, options);
      this.viewport.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') this.release('hover');
      }, options);
      this.viewport.addEventListener('pointerdown', (event) => this.onPointerDown(event), options);
      this.viewport.addEventListener('pointermove', (event) => this.onPointerMove(event), options);
      this.viewport.addEventListener('pointerup', (event) => this.onPointerUp(event), options);
      this.viewport.addEventListener('pointercancel', (event) => this.onPointerCancel(event), options);
      // A mouse released outside the banner never reaches the viewport.
      window.addEventListener('pointerup', (event) => this.onPointerCancel(event), options);
      window.addEventListener('pointercancel', (event) => this.onPointerCancel(event), options);
      this.viewport.addEventListener('click', (event) => this.onClickCapture(event), { signal: options.signal, capture: true });
      this.viewport.addEventListener('dragstart', (event) => event.preventDefault(), options);
      this.addEventListener('focusin', (event) => this.onFocusIn(event), options);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.hold('hidden');
        else this.release('hidden');
      }, options);
      this.reducedMotion.addEventListener('change', () => {
        if (this.reducedMotion.matches) this.stopRotation();
      }, options);
      document.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), options);
      document.addEventListener('shopify:block:deselect', (event) => this.onBlockDeselect(event), options);

      this.observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[entries.length - 1];
          if (entry.intersectionRatio >= 0.25) this.release('offscreen');
          else this.hold('offscreen');
          // Lets idle decoration stop once the banner is fully out of view.
          this.classList.toggle('is-offscreen', !entry.isIntersecting);
        },
        { threshold: [0, 0.25] }
      );
      this.observer.observe(this.viewport);

      if (document.readyState === 'complete') this.schedulePreload();
      else window.addEventListener('load', () => this.schedulePreload(), { signal: options.signal, once: true });

      this.reflect();
      this.restartClock();

      const remembered = window.Shopify && window.Shopify.designMode
        ? OfferSlideshow.selected.get(this.dataset.sectionId)
        : undefined;
      if (remembered !== undefined) {
        this.hold('editor');
        this.goTo(remembered, { instant: true });
      }
    }

    disconnectedCallback() {
      if (!this.controller) return;
      this.controller.abort();
      this.observer?.disconnect();
      clearTimeout(this.timer);
      this.timer = null;
      this.finishTimers.forEach(clearTimeout);
      this.finishTimers = [];
      clearTimeout(this.snapTimer);
      clearTimeout(this.preloadTimer);
      if (this.idleId && window.cancelIdleCallback) window.cancelIdleCallback(this.idleId);
      cancelAnimationFrame(this.dragFrame);
      this.fill?.cancel();
      this.fill = null;
      this.generation++;
    }

    // Autoplay clock. Holds are temporary reasons to wait (hover, a finger on
    // the slide, hidden tab, off screen, editor selection); userStopped is the
    // visitor's own choice. The clock is a timeout with remaining-time
    // bookkeeping, never an animation event: reduced-motion styles shorten
    // every CSS animation to almost nothing.
    hold(reason) {
      this.holds.add(reason);
      this.update();
    }

    release(reason) {
      if (this.holds.delete(reason)) this.update();
    }

    update() {
      const run = this.autoplay && !this.userStopped && this.holds.size === 0;

      if (run && !this.timer) {
        this.startedAt = performance.now();
        this.timer = setTimeout(() => this.tick(), this.remaining);
        this.fill?.play();
      } else if (!run) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
          this.remaining = Math.max(0, this.remaining - (performance.now() - this.startedAt));
        }
        this.fill?.pause();
      }

      this.viewport.setAttribute('aria-live', run ? 'off' : 'polite');
      this.classList.toggle('is-stopped', this.userStopped);
    }

    restartClock() {
      clearTimeout(this.timer);
      this.timer = null;
      this.remaining = this.interval;
      this.fill?.cancel();
      this.fill = null;

      const progress = this.tabs[this.index]?.querySelector('.offer-slideshow__progress');
      if (progress && progress.animate && this.autoplay && !this.userStopped && !this.reducedMotion.matches) {
        this.fill = progress.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], {
          duration: this.interval,
          easing: 'linear',
          fill: 'forwards',
        });
        this.fill.pause();
      }

      this.update();
    }

    tick() {
      this.timer = null;
      this.remaining = this.interval;
      // The header makes the page inert while its drawer or search is open.
      if (this.closest('[inert]')) {
        this.restartClock();
        return;
      }
      this.goTo(this.index + 1, { dir: 1, source: 'auto' });
    }

    stopRotation() {
      this.userStopped = true;
      this.restartClock();
      this.reflect();
    }

    toggleRotation() {
      if (this.userStopped) {
        this.userStopped = false;
        this.autoplay = true;
        this.restartClock();
        this.reflect();
      } else {
        this.stopRotation();
      }
    }

    reflect() {
      if (!this.rotation) return;
      const label = this.userStopped ? this.rotation.dataset.labelStart : this.rotation.dataset.labelStop;
      this.rotation.setAttribute('aria-label', label);
    }

    // Keyboard focus inside the carousel stops rotation until the visitor
    // presses play again (APG carousel pattern).
    onFocusIn(event) {
      if (event.target === this.rotation) return;
      let keyboard = false;
      try {
        keyboard = event.target.matches(':focus-visible');
      } catch (error) {
        keyboard = false;
      }
      if (keyboard) this.stopRotation();
    }

    onTabKeydown(event, i) {
      const count = this.tabs.length;
      const forward = this.rtl ? 'ArrowLeft' : 'ArrowRight';
      const back = this.rtl ? 'ArrowRight' : 'ArrowLeft';
      let target;

      if (event.key === forward) target = (i + 1) % count;
      else if (event.key === back) target = (i - 1 + count) % count;
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = count - 1;
      else return;

      event.preventDefault();
      this.tabs[target].focus();
      this.goTo(target, { dir: target > this.index ? 1 : -1 });
    }

    step(delta) {
      this.goTo(this.index + delta, { dir: delta });
    }

    async goTo(requested, { dir = 1, source = 'user', instant = false } = {}) {
      const count = this.slides.length;
      const target = ((requested % count) + count) % count;
      // Every request supersedes one still waiting for its image.
      const generation = ++this.generation;
      if (target === this.index) {
        this.restartClock();
        return;
      }

      const to = this.slides[target];

      // The autoplay timer must not overtake a visitor's choice while the
      // next image decodes.
      if (source !== 'auto') {
        clearTimeout(this.timer);
        this.timer = null;
        this.fill?.pause();
      }

      // Never fade in a half-decoded image; autoplay can afford to wait longer.
      if (!instant) {
        await this.ready(to, source === 'auto' ? 3000 : 450);
        if (generation !== this.generation || !this.isConnected) return;
        if (source === 'auto' && (this.userStopped || this.holds.size > 0)) {
          this.restartClock();
          return;
        }
      }

      this.finishTransition();

      const from = this.slides[this.index];
      const animate = !instant && !this.reducedMotion.matches;
      const hadFocus = from.contains(document.activeElement);

      this.style.setProperty('--offer-dir', dir < 0 ? '-1' : '1');
      from.classList.remove('is-active');
      from.inert = true;
      to.inert = false;
      to.classList.add('is-active');

      if (animate) {
        from.classList.add('is-leaving');
        to.classList.add('is-entering');
        this.finishTimers.push(
          setTimeout(() => {
            from.classList.remove('is-leaving');
            from.style.removeProperty('--offer-drag');
          }, this.timing.exit),
          setTimeout(() => to.classList.remove('is-entering'), this.timing.enter)
        );
      } else {
        from.style.removeProperty('--offer-drag');
      }

      this.index = target;
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === target));
        tab.tabIndex = i === target ? 0 : -1;
      });

      if (hadFocus) to.querySelector('.offer-slide__link')?.focus({ preventScroll: true });

      this.restartClock();
      this.preload(target + 1);
    }

    finishTransition() {
      this.finishTimers.forEach(clearTimeout);
      this.finishTimers = [];
      clearTimeout(this.snapTimer);
      this.slides.forEach((slide, i) => {
        slide.classList.remove('is-leaving', 'is-entering', 'is-snapping');
        if (i !== this.index) slide.style.removeProperty('--offer-drag');
      });
    }

    ready(slide, timeout) {
      const images = Array.from(slide.querySelectorAll('img'));
      images.forEach((image) => {
        image.loading = 'eager';
      });
      if (!images.length) return Promise.resolve();

      const decoded = Promise.allSettled(images.map((image) => (image.decode ? image.decode() : Promise.resolve())));
      return Promise.race([decoded, new Promise((resolve) => setTimeout(resolve, timeout))]);
    }

    preload(requested) {
      const count = this.slides.length;
      const slide = this.slides[((requested % count) + count) % count];
      slide.querySelectorAll('img[loading="lazy"]').forEach((image) => {
        image.loading = 'eager';
      });
    }

    schedulePreload() {
      const run = () => this.preload(this.index + 1);
      if ('requestIdleCallback' in window) this.idleId = window.requestIdleCallback(run, { timeout: 4000 });
      else this.preloadTimer = setTimeout(run, 2000);
    }

    // Swipe. The page keeps vertical scrolling (touch-action: pan-y); a
    // horizontal drag nudges the slide under the finger and commits past a
    // distance or flick threshold. Any drag suppresses the click that follows.
    onPointerDown(event) {
      this.moved = false;
      if (!event.isPrimary || event.button !== 0) return;
      if (event.target.closest('button')) return;

      const edge = 20;
      if (event.pointerType !== 'mouse') {
        if (event.clientX < edge || event.clientX > window.innerWidth - edge) return;
      }

      this.drag = {
        id: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        dx: 0,
        active: false,
        width: this.viewport.clientWidth,
        samples: [{ x: event.clientX, t: event.timeStamp }],
      };
      this.hold('pointer');
      this.preload(this.index - 1);
    }

    onPointerMove(event) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;

      const dx = event.clientX - drag.startX;
      const dy = event.clientY - drag.startY;

      if (!drag.active) {
        if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) {
          this.endDrag(false);
          return;
        }
        if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy) * 1.2) return;

        drag.active = true;
        this.moved = true;
        this.finishTransition();
        try {
          this.viewport.setPointerCapture(drag.id);
        } catch (error) {
          // The pointer may already be gone.
        }
        this.classList.add('is-dragging');
      }

      drag.dx = dx;
      drag.samples.push({ x: event.clientX, t: event.timeStamp });
      if (drag.samples.length > 5) drag.samples.shift();

      if (this.reducedMotion.matches) return;
      cancelAnimationFrame(this.dragFrame);
      this.dragFrame = requestAnimationFrame(() => {
        const limit = drag.width * 0.25;
        const offset = Math.max(-limit, Math.min(limit, dx * 0.5));
        this.slides[this.index].style.setProperty('--offer-drag', `${offset.toFixed(1)}px`);
      });
    }

    onPointerUp(event) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;

      if (drag.active) {
        const first = drag.samples[0];
        const last = drag.samples[drag.samples.length - 1];
        const velocity = last.t > first.t ? (last.x - first.x) / (last.t - first.t) : 0;
        const distance = Math.abs(drag.dx);
        const flick = Math.abs(velocity) > 0.4 && distance > 32 && Math.sign(velocity) === Math.sign(drag.dx);

        if (distance > Math.min(60, drag.width * 0.15) || flick) {
          const forward = drag.dx < 0 !== this.rtl;
          this.endDrag(false);
          this.goTo(this.index + (forward ? 1 : -1), { dir: forward ? 1 : -1 });
          return;
        }
      }

      this.endDrag(true);
    }

    onPointerCancel(event) {
      if (this.drag && event.pointerId === this.drag.id) this.endDrag(true);
    }

    endDrag(snap) {
      const drag = this.drag;
      this.drag = null;
      cancelAnimationFrame(this.dragFrame);
      this.classList.remove('is-dragging');

      if (drag) {
        try {
          if (this.viewport.hasPointerCapture(drag.id)) this.viewport.releasePointerCapture(drag.id);
        } catch (error) {
          // Nothing to release.
        }
      }

      if (snap && drag && drag.active) {
        const slide = this.slides[this.index];
        slide.classList.add('is-snapping');
        slide.style.setProperty('--offer-drag', '0px');
        clearTimeout(this.snapTimer);
        this.snapTimer = setTimeout(() => {
          slide.classList.remove('is-snapping');
          slide.style.removeProperty('--offer-drag');
        }, 340);
      }

      this.release('pointer');
    }

    onClickCapture(event) {
      if (this.moved && event.detail !== 0) {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    onBlockSelect(event) {
      if (!event.detail || event.detail.sectionId !== this.dataset.sectionId) return;
      const target = this.slides.findIndex((slide) => slide === event.target || slide.contains(event.target));
      if (target < 0) return;
      OfferSlideshow.selected.set(this.dataset.sectionId, target);
      this.hold('editor');
      this.goTo(target, { instant: true });
    }

    onBlockDeselect(event) {
      if (!event.detail || event.detail.sectionId !== this.dataset.sectionId) return;
      OfferSlideshow.selected.delete(this.dataset.sectionId);
      this.release('editor');
    }
  }

  if (!customElements.get('offer-slideshow')) {
    customElements.define('offer-slideshow', OfferSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.product__media-scroller');
      this.thumbs = Array.from(this.querySelectorAll('.product__thumb'));
      this.mediaVariants = this.readMediaVariants();

      if (this.mediaVariants) this.filterMedia(this.dataset.initialVariant);

      this.onVariantChange = (event) => {
        const variant = event.detail && event.detail.variant;
        if (!variant) return;
        if (this.mediaVariants) this.filterMedia(String(variant.id));
        this.showMedia(variant.featured_media ? String(variant.featured_media.id) : null);
      };
      document.addEventListener('variant:change', this.onVariantChange);

      if (this.thumbs.length === 0) return;

      const firstVisible = this.thumbs.find((thumb) => !thumb.closest('li').hidden) || this.thumbs[0];
      this.setCurrent(firstVisible.dataset.mediaId);

      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries.filter((entry) => entry.isIntersecting).pop();
          if (visible) this.setCurrent(visible.target.dataset.mediaId);
        },
        { root: this.querySelector('.product__media-scroller'), threshold: 0.6 }
      );

      this.querySelectorAll('.product__media').forEach((media) => observer.observe(media));
    }

    disconnectedCallback() {
      if (this.onVariantChange) document.removeEventListener('variant:change', this.onVariantChange);
    }

    readMediaVariants() {
      const data = this.querySelector('[data-media-variants]');
      if (!data) return null;
      try {
        const map = JSON.parse(data.textContent);
        return map && typeof map === 'object' && Object.keys(map).length ? map : null;
      } catch (error) {
        return null;
      }
    }

    // Photos tied to other variants are hidden; photos with no entry (or an empty
    // one) stay for all. Mirrors the Liquid first paint, which also accepts a
    // single id in place of a list.
    showsFor(mediaId, variantId) {
      const entry = this.mediaVariants[mediaId];
      if (entry === undefined || entry === null || entry === '') return true;
      const variants = Array.isArray(entry) ? entry : [entry];
      return variants.length === 0 || variants.map(String).includes(String(variantId));
    }

    filterMedia(variantId) {
      const slides = Array.from(this.querySelectorAll('.product__media[data-media-id]'));
      // A map that hides every photo is a data mistake: show them all instead.
      const showAll = !slides.some((media) => this.showsFor(media.dataset.mediaId, variantId));
      let firstVisible = null;
      slides.forEach((media) => {
        const show = showAll || this.showsFor(media.dataset.mediaId, variantId);
        media.hidden = !show;
        if (show && !firstVisible) firstVisible = media;
      });
      this.thumbs.forEach((thumb) => {
        thumb.closest('li').hidden = !(showAll || this.showsFor(thumb.dataset.mediaId, variantId));
      });
      if (firstVisible) this.setCurrent(firstVisible.dataset.mediaId);
    }

    showMedia(mediaId) {
      if (!this.scroller) return;
      const visible = Array.from(this.scroller.querySelectorAll('.product__media[data-media-id]')).filter((media) => !media.hidden);
      const target = visible.find((media) => media.dataset.mediaId === mediaId) || visible[0];
      if (!target) return;
      const left = this.scroller.scrollLeft + target.getBoundingClientRect().left - this.scroller.getBoundingClientRect().left;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.scroller.scrollTo({ left, behavior: reduceMotion ? 'auto' : 'smooth' });
      this.setCurrent(target.dataset.mediaId);
    }

    setCurrent(mediaId) {
      this.thumbs.forEach((thumb) => {
        thumb.setAttribute('aria-current', String(thumb.dataset.mediaId === mediaId));
      });
    }
  }

  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        const step = button.name === 'plus' ? 1 : -1;
        const min = Number(this.input.min || 1);
        this.input.value = Math.max(min, Number(this.input.value) + step);
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  class VariantPicker extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.addEventListener('change', () => this.onChange());
      this.updateAvailability();
    }

    get checkedInputs() {
      return Array.from(this.querySelectorAll('input[type="radio"]:checked'));
    }

    get selectedOptions() {
      return this.checkedInputs.map((input) => input.value);
    }

    findVariant(options) {
      return this.variants.find((variant) =>
        options.every((value, index) => variant.options[index] === value)
      );
    }

    onChange() {
      const variant = this.findVariant(this.selectedOptions);
      const checked = this.checkedInputs;

      this.querySelectorAll('[data-selected-option]').forEach((element) => {
        const input = checked.find((item) => item.dataset.optionPosition === element.dataset.selectedOption);
        element.textContent = input ? input.dataset.label || input.value : '';
      });

      this.updateAvailability();

      const idInput = document.querySelector('[data-variant-id]');
      const buttons = Array.from(document.querySelectorAll('[data-add-button]'));

      if (!variant) {
        buttons.forEach((button) => {
          button.disabled = true;
          button.textContent = button.dataset.unavailableLabel;
        });
        return;
      }

      if (idInput) idInput.value = variant.id;

      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant } }));

      buttons.forEach((button) => {
        button.disabled = !variant.available;
        button.textContent = variant.available ? button.dataset.addLabel : button.dataset.soldOutLabel;
      });

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      this.refreshPrice(variant.id);
    }

    updateAvailability() {
      const selected = this.selectedOptions;

      this.querySelectorAll('input[type="radio"]').forEach((input) => {
        const position = Number(input.dataset.optionPosition) - 1;
        const candidate = selected.slice();
        candidate[position] = input.value;
        const match = this.findVariant(candidate);
        const label = this.querySelector(`label[for="${input.id}"]`);
        if (!label) return;
        const unavailable = !match || !match.available;
        label.dataset.unavailable = String(unavailable);
        const note = label.querySelector('[data-unavailable-text]');
        if (note) note.hidden = !unavailable;
      });
    }

    async refreshPrice(variantId) {
      const url = `${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.section}`;
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      try {
        const response = await fetch(url, { signal: this.controller.signal });
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        document.querySelectorAll('[data-price-target]').forEach((current) => {
          const fresh = current.id ? html.getElementById(current.id) : null;
          if (fresh) current.innerHTML = fresh.innerHTML;
        });
        const price = document.getElementById('product-price');
        if (window.ppAnnounce && price) window.ppAnnounce(price.textContent.replace(/\s+/g, ' ').trim());
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error('Unable to refresh the price', error);
      }
    }
  }

  class StickyBar extends HTMLElement {
    connectedCallback() {
      this.purchase = document.querySelector('.product__purchase');
      if (!this.purchase || !('IntersectionObserver' in window)) return;

      // The markup ships hidden (the no-JavaScript default). From here the bar
      // stays rendered, parked below the screen, and .is-visible slides it in.
      this.hidden = false;
      this.media = window.matchMedia('(max-width: 749px)');
      this.observer = new IntersectionObserver((entries) => this.toggle(!entries[0].isIntersecting), { threshold: 0.2 });
      this.observer.observe(this.purchase);
      this.media.addEventListener('change', () => this.toggle(this.visible));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      document.documentElement.style.removeProperty('--sticky-bar-height');
    }

    toggle(show) {
      this.visible = show;
      const active = show && this.media.matches;
      this.classList.toggle('is-visible', active);
      if (active) {
        document.documentElement.style.setProperty('--sticky-bar-height', `${this.offsetHeight}px`);
      } else {
        document.documentElement.style.removeProperty('--sticky-bar-height');
      }
    }
  }

  // Shopify renders its Buy it now button after the page loads and can render
  // it again, so the label is set on every change inside the wrapper. Setting
  // the same text again changes nothing, so the observer settles at once.
  class BuyNowLabel extends HTMLElement {
    connectedCallback() {
      this.label = (this.dataset.label || '').trim();
      if (!this.label) return;
      this.observer = new MutationObserver(() => this.apply());
      this.observer.observe(this, { childList: true, subtree: true, characterData: true });
      this.apply();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    apply() {
      this.querySelectorAll('.shopify-payment-button__button--unbranded').forEach((button) => {
        if (button.textContent.trim() !== this.label) button.textContent = this.label;
      });
    }
  }

  class ShareButton extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', async (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        const payload = { title: this.dataset.title, url: this.dataset.url };

        if (navigator.share) {
          try {
            await navigator.share(payload);
          } catch (error) {
            // Dismissed the share sheet.
          }
          return;
        }

        try {
          await navigator.clipboard.writeText(payload.url);
          const label = this.querySelector('[data-share-label]');
          const original = label ? label.textContent : '';
          if (label) label.textContent = this.dataset.copied;
          if (window.ppAnnounce) window.ppAnnounce(this.dataset.copied);
          setTimeout(() => {
            if (label) label.textContent = original;
          }, 2000);
        } catch (error) {
          window.prompt(this.dataset.title, payload.url);
        }
      });
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }

  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', QuantityInput);
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }

  if (!customElements.get('sticky-bar')) {
    customElements.define('sticky-bar', StickyBar);
  }

  if (!customElements.get('share-button')) {
    customElements.define('share-button', ShareButton);
  }

  if (!customElements.get('buy-now-label')) {
    customElements.define('buy-now-label', BuyNowLabel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  class RelatedProducts extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) {
        this.load();
        return;
      }

      const observer = new IntersectionObserver((entries, self) => {
        if (!entries[0].isIntersecting) return;
        self.disconnect();
        this.load();
      }, { rootMargin: '0px 0px 400px 0px' });

      observer.observe(this);
    }

    async load() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const markup = html.querySelector('related-products');
        // Keep the collection products already on the page unless Shopify
        // returned real recommendations.
        if (markup && markup.querySelector('.product-grid__item')) this.innerHTML = markup.innerHTML;
      } catch (error) {
        console.error('Unable to load product recommendations', error);
      }
    }
  }

  if (!customElements.get('related-products')) {
    customElements.define('related-products', RelatedProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-predictive-input]');
      this.panel = this.querySelector('[data-predictive-panel]');
      if (!this.input || !this.panel || !this.dataset.url || this.ready) return;

      this.ready = true;
      this.cache = new Map();
      this.activeIndex = -1;
      // Element.prototype.prefix is a read-only getter, so the id prefix needs its own name.
      this.idPrefix = this.input.id || 'predictive';

      this.input.addEventListener('input', () => this.schedule());
      this.input.addEventListener('keydown', (event) => this.onKeydown(event));
      this.input.addEventListener('focus', () => {
        if (this.panel.childElementCount > 0 && this.term().length >= 2) this.show();
      });

      this.panel.addEventListener('mousedown', (event) => event.preventDefault());

      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.hide();
      });

      const form = this.input.form;
      if (form) form.addEventListener('submit', () => this.hide());
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.controller) this.controller.abort();
    }

    term() {
      return this.input.value.trim();
    }

    schedule() {
      clearTimeout(this.timer);
      const term = this.term();
      if (term.length < 2) {
        if (this.controller) this.controller.abort();
        this.hide();
        return;
      }
      this.timer = setTimeout(() => this.load(term), 220);
    }

    async load(term) {
      const key = term.toLowerCase();
      if (this.cache.has(key)) {
        this.render(this.cache.get(key));
        return;
      }

      if (this.controller) this.controller.abort();
      const controller = new AbortController();
      this.controller = controller;
      this.setAttribute('aria-busy', 'true');

      const params = new URLSearchParams({
        q: term,
        section_id: this.dataset.section || 'search',
        'resources[type]': 'product',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
      });

      try {
        const response = await fetch(`${this.dataset.url}?${params.toString()}`, { signal: controller.signal });
        if (!response.ok) throw new Error(String(response.status));
        const html = await response.text();
        const results = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-predictive-results]');
        if (!results) {
          this.hide();
          return;
        }
        this.cache.set(key, results.outerHTML);
        if (this.term().toLowerCase() === key) this.render(results.outerHTML);
      } catch (error) {
        if (error.name !== 'AbortError') this.hide();
      } finally {
        if (this.controller === controller) this.removeAttribute('aria-busy');
      }
    }

    render(markup) {
      this.panel.innerHTML = markup;
      // Results re-render on every keystroke; skip the first-load fade so thumbnails don't blink.
      this.panel.querySelectorAll('img').forEach((img) => img.classList.add('is-loaded'));
      this.activeIndex = -1;
      this.input.removeAttribute('aria-activedescendant');

      this.panel.querySelectorAll('[id]').forEach((element) => {
        element.id = `${this.idPrefix}-${element.id}`;
      });
      this.panel.querySelectorAll('[aria-labelledby]').forEach((element) => {
        element.setAttribute('aria-labelledby', `${this.idPrefix}-${element.getAttribute('aria-labelledby')}`);
      });

      const listbox = this.panel.querySelector('[role="listbox"]');
      this.input.setAttribute('aria-controls', listbox ? listbox.id : this.panel.id);

      if (document.activeElement !== this.input) return;
      this.show();

      const results = this.panel.querySelector('[data-predictive-results]');
      if (results && results.dataset.announce && window.ppAnnounce) window.ppAnnounce(results.dataset.announce);
    }

    options() {
      return [...this.panel.querySelectorAll('[role="option"]')];
    }

    onKeydown(event) {
      const options = this.options();

      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowUp': {
          if (options.length === 0) return;
          event.preventDefault();
          if (this.panel.hidden) this.show();
          const step = event.key === 'ArrowDown' ? 1 : -1;
          const next = this.activeIndex + step;
          this.setActive(next < 0 ? options.length - 1 : next % options.length, options);
          break;
        }
        case 'Enter': {
          if (this.panel.hidden || this.activeIndex < 0 || !options[this.activeIndex]) return;
          const link = options[this.activeIndex].querySelector('a[href]');
          if (!link) return;
          event.preventDefault();
          window.location.href = link.href;
          break;
        }
        case 'Escape': {
          if (this.panel.hidden) return;
          event.preventDefault();
          this.hide();
          break;
        }
        default:
          break;
      }
    }

    setActive(index, options) {
      this.activeIndex = index;
      options.forEach((option, position) => option.setAttribute('aria-selected', String(position === index)));
      const active = options[index];
      if (!active) return;
      this.input.setAttribute('aria-activedescendant', active.id);
      active.scrollIntoView({ block: 'nearest' });
    }

    show() {
      if (this.panel.childElementCount === 0) return;
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    hide() {
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.options().forEach((option) => option.setAttribute('aria-selected', 'false'));
      this.activeIndex = -1;
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }

  } catch(e) { console.error(e); }
})();
})();
